import React from 'react';
import {Badge, Text} from '@chakra-ui/react';
import {PhoneIcon} from '@chakra-ui/icons'

export default function PhoneNumber({number, ...props}) {
  return (
    <>
      {number ?
      <a href={`tel:${number}`}>
        <Badge borderRadius='full' variant='subtle' colorScheme='gray'>
          <Text fontSize={'13px'} mx={1} my={1}>
            <PhoneIcon color={'green.500'} mb={"3px"} mr={"5px"}/>
            {number}
          </Text>
        </Badge>
      </a> : '--'
      }
    </>
  )
}
